import * as BaggageDeleteButton from './components/BaggageDeleteButton.css';

export default {
	BaggageDeleteButton
};
